import { Browser } from '@capacitor/browser';
import { isNativeMobileApp } from './platform';

export async function openExternalUrl(url) {
  const target = String(url || '').trim();
  if (!target) return;

  if (isNativeMobileApp()) {
    await Browser.open({ url: target });
    return;
  }

  if (typeof window !== 'undefined') {
    window.location.assign(target);
  }
}
